(function () {
  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();


/* === Mystery Plant Popup - Pretty Plants === */
(function() {
  var VARIANT_ID = 58000041804108;
  var SESSION_CLOSED = 'pp_mystery_closed';
  var SESSION_CART = 'pp_mystery_cart';

  window.closeMysteryPopup = function() {
    var p = document.getElementById('mystery-plant-popup');
    if (p) p.style.display = 'none';
    try { sessionStorage.setItem(SESSION_CLOSED, '1'); } catch(e) {}
  };

  window.openMysteryPopup = function() {
    var p = document.getElementById('mystery-plant-popup');
    if (p) { p.style.display = ''; return true; }
    return false;
  };

  function addToCartOnce() {
    var cartDone = false;
    try { cartDone = !!sessionStorage.getItem(SESSION_CART); } catch(e) {}
    if (cartDone) return;
    try { sessionStorage.setItem(SESSION_CART, '1'); } catch(e) {}
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var found = (cart.items||[]).some(function(it){ return String(it.variant_id)===String(VARIANT_ID); });
      if (found) return;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:VARIANT_ID,quantity:1}]})}).catch(function(){});
    }).catch(function(){});
  }

  function initMystery() {
    if (window.location.pathname.indexOf('/checkout') !== -1) return;
    var closed = false;
    try { closed = !!sessionStorage.getItem(SESSION_CLOSED); } catch(e) {}
    if (!closed) {
      window.openMysteryPopup();
      addToCartOnce();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMystery);
  } else {
    initMystery();
  }

  document.addEventListener('page:loaded', initMystery);
  window.addEventListener('popstate', function(){ setTimeout(initMystery, 100); });

  var obs = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.id === 'shopify-section-mystery-plant-popup' ||
            (n.nodeType === 1 && n.querySelector && n.querySelector('#mystery-plant-popup'))) {
          setTimeout(initMystery, 50);
        }
      });
    });
  });
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
/* === End Mystery Plant Popup === */